module.exports = __webpack_public_path__ + "static/wikipedia-cognitive-biases-zoom-e1578e814b74677953dc6dcf6fbfe353.png";